import { cssRule } from 'typestyle';

cssRule('.tb-scroll', {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    overflowX: 'auto',
    overflowY: 'auto',
    outline: 0,
});

cssRule('.tb-scroll.tb-tabs-banner-subplace-settings-banner', {
    top: '36px',
});

cssRule('.tb-scroll-content-area', {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
});

cssRule('.tb-scroll-content', {
    position: 'absolute',
    left: 0,
    right: 0,
    lineHeight: 0,
});

